import React, { useState } from 'react'

function scoreColor(s) {
  if (s >= 80) return 'var(--score-excellent)'
  if (s >= 65) return 'var(--score-good)'
  if (s >= 50) return 'var(--score-moderate)'
  if (s >= 35) return 'var(--score-marginal)'
  return 'var(--score-poor)'
}

export default function ComparePanel({
  queue, onRemove, onClear, onRunCompare,
  compareResult, compareLoading, compareError,
  technology, country, capacityMw,
}) {
  const [panel, setPanel] = useState('queue')

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {/* Queue */}
      <div className="card">
        <div className="card__title">Compare Queue ({queue.length}/10)</div>
        {queue.length === 0 ? (
          <div style={{ color: 'var(--color-muted)', fontSize: 12 }}>
            Click sites on the map to add them to the compare queue.
          </div>
        ) : (
          <>
            <table className="data-table" style={{ marginBottom: 10 }}>
              <tbody>
                {queue.map((s, i) => (
                  <tr key={i}>
                    <td>{s.label}</td>
                    <td style={{ fontFamily: 'var(--font-mono)' }}>
                      {s.lat.toFixed(3)}, {s.lon.toFixed(3)}
                    </td>
                    <td>
                      <button
                        className="btn btn-danger"
                        style={{ padding: '2px 8px', fontSize: 11 }}
                        onClick={() => onRemove(i)}
                      >
                        ✕
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ display: 'flex', gap: 8 }}>
              <button
                className="btn btn-primary"
                disabled={queue.length < 2 || compareLoading}
                onClick={onRunCompare}
                style={{ flex: 1 }}
              >
                {compareLoading ? 'Comparing…' : `Compare ${queue.length} Sites`}
              </button>
              <button className="btn btn-secondary" onClick={onClear}>Clear</button>
            </div>
          </>
        )}
      </div>

      {compareError && (
        <div className="alert alert-danger">{compareError}</div>
      )}

      {compareLoading && (
        <div className="loading-overlay">
          <div className="spinner" />
          <span>Running {queue.length} concurrent assessments…</span>
        </div>
      )}

      {/* Results */}
      {compareResult && !compareLoading && (
        <>
          {compareResult.comparison_notes?.map((n, i) => (
            <div key={i} className="alert alert-info">{n}</div>
          ))}

          {compareResult.best_site && (
            <div className="card">
              <div className="card__title">Best Site</div>
              <div style={{ fontWeight: 600 }}>{compareResult.best_site.label}</div>
              <div style={{ fontSize: 12, color: 'var(--color-muted)', marginTop: 4 }}>
                Score: <strong style={{ color: scoreColor(compareResult.best_site.overall_score) }}>
                  {compareResult.best_site.overall_score?.toFixed(0)}
                </strong> · LCOE: ${compareResult.best_site.financial?.lcoe_usd_per_mwh?.toFixed(1)}/MWh
              </div>
            </div>
          )}

          <div className="card" style={{ overflowX: 'auto' }}>
            <div className="card__title">Rankings</div>
            <table className="compare-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Site</th>
                  <th>Score</th>
                  <th>LCOE</th>
                  <th>IRR</th>
                  <th>CF%</th>
                  <th>Grid km</th>
                  <th>Excl.</th>
                </tr>
              </thead>
              <tbody>
                {compareResult.rankings?.map(r => (
                  <tr key={r.rank}>
                    <td>{r.rank}</td>
                    <td>{r.label}</td>
                    <td style={{ color: scoreColor(r.overall_score), fontWeight: 700 }}>
                      {r.overall_score?.toFixed(0)}
                    </td>
                    <td>${r.financial?.lcoe_usd_per_mwh?.toFixed(1)}</td>
                    <td>{r.financial?.irr_pct?.toFixed(1)}%</td>
                    <td>{((r.yield?.capacity_factor ?? 0) * 100).toFixed(1)}%</td>
                    <td>{r.grid?.nearest_substation_km?.toFixed(1)}</td>
                    <td style={{ color: r.suitability?.is_excluded ? 'var(--red)' : 'var(--green)', fontWeight: 600 }}>
                      {r.suitability?.is_excluded ? 'Excl.' : 'OK'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}
